<template>
  <v-row no-gutters class="pl-3">
    <v-menu
      v-model="showMenu"
      down
      offset-y
      style="max-width: 600px"
      rounded='lg' transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-col class="pointer"
               v-bind="attrs"
               v-on="on">
          <v-icon color="white">mdi-account-circle-outline</v-icon>
          <span class="white--text">{{ user.username }}</span>
        </v-col>
      </template>

      <v-list>
        <div v-for="(item, index) in text.pages.userMenu"
             :key="index" class="pa-4">
          <v-list-item
          >
            <v-list-item-title class="pointer"
                               @click="$router.push(item.link)">{{ item.name }}
            </v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
        </div>
        <v-list-item-action>
          <v-btn @click="logout" small>
            {{ text.buttons.logout }}
          </v-btn>
        </v-list-item-action>
      </v-list>
    </v-menu>
  </v-row>
</template>

<script>
import { translations } from '@/lang/translations';
import router from '@/router';
import Axios from '@/core/Axios';

export default {
  name: 'UserLogged',
  data() {
    return {
      axios: new Axios(),
      showMenu: false,
    };
  },
  computed: {
    text() {
      return translations[this.$store.state.language];
    },
    user() {
      return {
        username: this.$store.state.user.username,
      };
    },
  },
  mounted() {
    this.getCusomerData();
  },
  methods: {
    getCusomerData() {
      this.axios.makeCall('GET', `norbit/customer/${this.$store.state.user.uid}`)
        .then((response) => console.log('ok'))
        .catch((error) => console.log('error'));
    },
    logout() {
      sessionStorage.removeItem(btoa('user'));
      this.$store.commit('loginUser', null);
    },
  },
};
</script>

<style scoped>
.white {
  color: #ffffff;
}
</style>
